<template>
  <div class="text-subtitle-underline">最近見た動画（閲覧履歴）</div>
  <template v-if="Array.isArray(browsings) && browsings.length">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-3">
      <div v-for="item in browsings" :key="item.id">
        <template v-if="item.video">
          <router-link
            :to="`/video/${item.video.id}`"
          >
            <video-thumbnail :video="item.video" />
          </router-link>
        </template>
      </div>
    </div>
    <div class="text-right">
      <router-link
        to="/video/browsing-history"
        class="text-link text-sm"
      >
        すべての閲覧履歴を見る>
      </router-link>
    </div>
  </template>
  <template v-else>
    <div class="h-40 px-2">
      最近見た動画はありませんでした。
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import VideoThumbnail from '@/components/VideoThumbnail.vue'
import { VideoBrowsingAttributes } from '@/types/models/video-browsing'
import { toArray } from '@/utils/array'

export default defineComponent({
  props: {
    browsings: {
      type: Array as PropType<VideoBrowsingAttributes[] | undefined>,
      'default': () => ([]),
    }
  },
  components: { VideoThumbnail },
  setup() {
    return {
      toArray,
    }
  },
})
</script>
